//import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],

    async created() {
        await this.CheckLoginStatus();

        this.ruleForm.Name = this.loginDetails.name;
        this.ruleForm.LoginName = this.loginDetails.loginName;
        this.ruleForm.Email = this.loginDetails.email;
        this.ruleForm.Phone = this.loginDetails.phone;
    },

    data() {
        var validatePass = (rules, value, callback) => {
            if (value === '') {
                callback(new Error('الرجاء إدخال كلمة المرور الحالية'));
            } else {
                callback();
            }
        };
        var validateNewPass = (rules, value, callback) => {
            if (value === '') {
                callback(new Error('الرجاء إدخال كلمة المرور الجديدة'));
            } else if (this.PasswordruleForm.ConfirmPassword !== '' && this.PasswordruleForm.ConfirmPassword !== value) {
                this.$refs.PasswordruleForm && this.$refs.PasswordruleForm.validateField('ConfirmPassword');
                callback();
            } else {
                callback();
            }
        };
        var validateConfirmPass = (rules, value, callback) => {
            if (value === '') {
                callback(new Error('الرجاء تأكيد كلمة المرور الجديدة'));
            } else if (value !== this.PasswordruleForm.NewPassword) {
                callback(new Error('الرجاء التأكد من تطابق كلمة المرور'));
            } else {
                callback();
            }
        };
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            pageNoT: 1,
            pageSizeT: 10,
            pagesT: 0,
            state: 0,
            Search: '',

            ScreenTitle: '  المستخدمين ',
            ScreenTitleSingle: '  مستخدم   ',
            ScreenTitleSingleAl: ' المستخدم  ',

            Info: [],
            InfoT: [],
            Statistics: [],

            AddDialog: false,

            SelectedItem: '',

            ruleForm: {
                Id: '',
                Name: '',
                LoginName: 'رفيق',
                Email: '',
                Phone: '',
                Image: '',
                ImageName: '',
                Password: '',
                ConfirmPassword: '',
                NewPassword: '',
            },
            rules: {
                Name: this.$helper.Required(),
                Phone: this.$helper.Phone(),
                Email: this.$helper.EmailOnly(),
                LoginName: [
                    { required: true, message: 'الرجاء إدخال اسم الدخول', trigger: 'blur' },
                    { required: true, pattern: /^[A-Za-z]{0,40}$/, message: 'الرجاء إدخال اسم الدخول بطريقه صحيحه', trigger: 'blur' }
                ],
            },


            PasswordruleForm: {
                Id: '',
                Password: '',
                ConfirmPassword: '',
                NewPassword: '',
            },
            Passwordrules: {
                Password: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                NewPassword: [
                    { validator: validateNewPass, trigger: 'blur' },
                    { pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/, message: 'كلمة المرور: 8 خانات على الأقل، تحتوي على حروف صغيرة وكبيرة وأرقام', trigger: 'blur' }
                ],
                ConfirmPassword: [
                    { validator: validateConfirmPass, trigger: 'blur' }
                ],
            },

            PoicruleForm: {
                Id: '',
                Image: '',
                ImageName: '',
            },
            Picrules: {
                Image: this.$helper.Required(),
                ImageName: this.$helper.Required(),
                
            },
        };
    },



    methods: {

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);
                    this.$blockUI.Start();
                    this.$http.ChangeProfileInfo(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            try {
                                const raw = localStorage.getItem('currentUser-client');
                                if (raw) {
                                    const obj = JSON.parse(this.decrypt(raw, this.PlatFormPass));
                                    obj.name = this.ruleForm.Name;
                                    obj.email = this.ruleForm.Email;
                                    obj.phone = this.ruleForm.Phone;
                                    localStorage.setItem('currentUser-client', this.encrypt(JSON.stringify(obj), this.PlatFormPass));
                                    this.loginDetails = obj;
                                }
                            } catch (e) { /* non-critical */ }
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        submitChangePasswordForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.$helper.showSwal('warning');
                    return false;
                }

                if (this.PasswordruleForm.NewPassword !== this.PasswordruleForm.ConfirmPassword) {
                    this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'الرجاء التأكد من تطابق كلمة المرور');
                    return;
                }

                if (this.PasswordruleForm.NewPassword === this.PasswordruleForm.Password) {
                    this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'كلمة المرور الجديدة يجب أن تختلف عن الحالية');
                    return;
                }

                this.PasswordruleForm.Id = 0;
                this.$blockUI.Start();
                this.$http.ChangeProfilePassword(this.PasswordruleForm)
                    .then(response => {
                        this.$blockUI.Stop();
                        this.ClearForm(this.PasswordruleForm);
                        this.$refs[formName].resetFields();
                        this.$helper.DestroyElemntById('Close');
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        if (err.response && err.response.data) {
                            this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                        } else {
                            this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                        }
                    });
            });
        },

        SelectImage(file) {

            // Check if file is defined
            if (!file) {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type; // Access type property safely
            str = str.substring(0, 5);

            // Check if the file type is an image
            if (str !== "image") {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            var $this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.PoicruleForm.ImageName = file.name;
                $this.PoicruleForm.Image = reader.result;


                $this.$blockUI.Start();
                $this.$http.ChangeProfilePicture($this.PoicruleForm)
                    .then((response) => {
                        $this.$blockUI.Stop();
                        $this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        // Update the cached avatar locally so header refreshes without forcing logout.
                        try {
                            const raw = localStorage.getItem('currentUser-client');
                            if (raw) {
                                const obj = JSON.parse($this.decrypt(raw, $this.PlatFormPass));
                                obj.image = $this.PoicruleForm.Image;
                                localStorage.setItem('currentUser-client', $this.encrypt(JSON.stringify(obj), $this.PlatFormPass));
                                $this.loginDetails = obj;
                            }
                        } catch (e) { /* keep silent — non-critical */ }
                    })
                    .catch((err) => {
                        $this.$blockUI.Stop();
                        if (err.response && err.response.data) {
                            $this.$helper.ShowMessage('error', 'خطأ بعملية تغير الصورة', err.response.data);
                        } else {
                            $this.$helper.ShowMessage('error', 'خطأ بعملية تغير الصورة ', 'حدت خطاء غير متوقع');
                        }
                    });
                return;


            };
        },


    }
}
